import axios from '../axios';
//日志
export const getBasePriceLogPage = data => {
  return axios({
    url: '/api/sys/base/getBasePriceLogPage',
    method: 'post',
    data
  })
};
//系统业务日志列表（评铁日志）
export const getSysBusinessLogPage = data => {
  return axios({
    url: '/api/sys/sys/business/log/getSysBusinessLogPage',
    method: 'post',
    data
  })
};

// 查询单条系统业务日志
export const getSysBusinessLog = data => {
  return axios({
    url: '/api/sys/sys/business/log/getSysBusinessLog',
    method: 'post',
    data
  })
};

// 新增系统业务日志（一般内部调用）
export const saveSysBusinessLog = data => {
  return axios({
    url: '/api/sys/sys/business/log/saveSysBusinessLog',
    method: 'post',
    data
  })
};

// 确认系统业务日志（auditFlag=1）
export const auditSysBusinessLogs = data => {
  return axios({
    url: '/api/sys/sys/business/log/auditSysBusinessLogs',
    method: 'post',
    data
  })
};

// 反确认系统业务日志（auditFlag=0）
export const unauditSysBusinessLogs = data => {
  return axios({
    url: '/api/sys/sys/business/log/unauditSysBusinessLogs',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/editlog.js